module.exports = __webpack_public_path__ + "static/media/white_read.5d6bfdd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_read.svg
// module id = 238
// module chunks = 0